export var FindingExclusionScope;
(function (FindingExclusionScope) {
    FindingExclusionScope["FINDING_EXCLUSION_SCOPE_RESOURCE"] = "RESOURCE";
    FindingExclusionScope["FINDING_EXCLUSION_SCOPE_ACCOUNT"] = "ACCOUNT";
})(FindingExclusionScope || (FindingExclusionScope = {}));
